export const LOADING_TEXT = 'Loading training data...'
